import { defineStore } from "pinia";
import { AxiosClient } from "../axios/axios";
import router from "../router";
export const useAuthStore = defineStore("authStore", {
  state: () => ({
    user: null,
    name: null,
    email: null,
    prvi: [],
    token: localStorage.getItem("token") || null,
    error: null,
    errors: {},
    isLoading: false,
  }),

  getters: {
    isLoggedIn: (state) => state.token !== null,
  },
  actions: {
    //Clear errors Action Start
    async clearErrors() {
      this.error = null;
      this.errors = null;
    },
    //clear errors end start
    async login(formData) {
      return new Promise((resolve, reject) => {
        AxiosClient.post(`/login`, formData, {
          withCredentials: true,
        })
          .then((res) => {
            localStorage.setItem("token", res.data.userToken);
            this.token = res.data.userToken;
            this.isLoading = false;
            router.push({ name: "dashboard" });
            // resolve(res)
          })
          .catch((error) => {
            this.isLoading = false;
            reject(error);
          });
      });
    },
    //Login Action End
    //Logout Action Start
    async logout() {
      // Clear the token and user data
      try {
        await AxiosClient.get(`/logout`, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
          withCredentials: true,
        });
        if (this.token) {
          localStorage.removeItem("token");
        }
        this.user = null;
        this.token = null;
        router.push({ name: "login" });
      } catch (error) {
        if (this.token) {
          localStorage.removeItem("token");
        }
        this.error = error?.response?.data?.message ?? "An error occurred";
        this.user = null;
        router.push({ name: "login" });
      }
    },
    //Logout Action End

    // Get User Action Start
    async getUser() {
      try {
        const res = await AxiosClient.get(`/user`, {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("token") ?? this.token,
          },
          withCredentials: true,
        });
        if (res.status === 201) {
          // results request
          this.user = res?.data?.user?.info;
          this.name = res?.data?.user?.info?.name;
          this.email = res?.data?.user?.info?.email;
          this.prvi = res?.data?.user?.abilities;
          return res.data;
        } else {
          if (this.token) {
            localStorage.removeItem("token");
          }
          this.user = null;
        }
      } catch (error) {
        if (this.token) {
          // localStorage.removeItem("token");
        }
        this.user = null;
        this.error = error?.response?.data?.message ?? "An error occurred";
      }
    },
    // Get User Action End

    // get privileges

    getPrivileges() {
      return new Promise((resolve, reject) => {
        AxiosClient.get(`/privileges`, {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("token") ?? this.token,
          },
        })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // end of get privileges
  },
});
